import { render, staticRenderFns } from "./AddVendorApiWizardControl.global.vue?vue&type=template&id=49b3a174&lang=pug&"
import script from "./AddVendorApiWizardControl.global.vue?vue&type=script&lang=ts&"
export * from "./AddVendorApiWizardControl.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports